import React from "react";
import AttachmentContent from "./attachment-content.jsx";
import ActivitiesContent from "./activities-content.jsx";
import ScheduleGarrisonUtils from "../utils/schedulegarrison-utils.jsx";

const DeleteContent = ({ element }) => {
    let deleteData;

    try {
        deleteData = typeof element?.details === "string" ? JSON.parse(element.details) : element?.details ?? {};
    } catch {
        deleteData = {};
    }

    const attachments = deleteData.attachment;
    const activities = deleteData.activities;
    const group = deleteData.garrison_group ?? {};

    const hasContent = ScheduleGarrisonUtils.hasVisibleFields(deleteData);
    if (!hasContent) return;

    return (
        <tr className="delete-content-table">
            <td colSpan={14}>
                <table className="applied insider w-full">
                    <thead>
                        <tr className="text-left">
                            <th style={{ width: "30%" }}>Campo</th>
                            <th style={{ width: "70%" }}>Antigo</th>
                        </tr>
                    </thead>

                    <tbody>
                        <ScheduleGarrisonUtils.Row
                            label="Nome"
                            value={deleteData.name}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Cadastro"
                            value={element.date_time}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Período disponível"
                            value={ScheduleGarrisonUtils.formatPeriod(
                                deleteData.date_usage_min,
                                deleteData.date_usage_max
                            )}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Descrição"
                            value={deleteData.description}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Inativar"
                            value={deleteData.inactive}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Motivo da inativação"
                            value={deleteData.inactive_observation}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Dias da semana"
                            value={ScheduleGarrisonUtils.formatWeekdays(group.weekdays)}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Equipe"
                            value={ScheduleGarrisonUtils.formatArray(group.teams)}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Função destinada"
                            value={ScheduleGarrisonUtils.formatGroupFunctions(group.intendedFunctions)}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Setor"
                            value={ScheduleGarrisonUtils.formatArray(group.sectors)}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Atribuir automaticamente às guarnições"
                            value={deleteData.auto_apply_by_group}
                        />

                        { activities && (
                            <ActivitiesContent
                                activities={activities}
                            />
                        )}

                        { attachments && (
                            <AttachmentContent
                                attachments={attachments}
                            />
                        )}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default DeleteContent;